import $ from 'jquery';
import Registry from '../Registry';

class Widget {

    constructor(args){
        this.args = args;
        Registry.d("Widget.constructor");
        this.iframe = false;
        for (let key in this.args) {
            this[key] = this.args[key];
        }

        $(window).off("resize.Widget").on("resize.Widget", () => Registry.autoAdjust());
    }

    notify(key, val){
        Registry.d(`Widget.notify ${key}: ${val}`);
        if (this.iframe) {
            if (this.iframe[0]) {
                if (this.iframe[0].contentWindow) {
                    return this.iframe[0].contentWindow.postMessage(JSON.stringify({key, value: val}), '*');
                }
            }
        }
    }
}

export default Widget;






// WEBPACK FOOTER //
// ./src/embed/widgets/Widget.es6